import Vue from "vue";

export default {
  SET_STATE(state, payload) {
    state[payload.key] = payload.value;
  }
};
